import React from 'react'

import PropTypes from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import Icon from './Icon/Icon'
import Tooltip from './Tooltip'

function InputFieldWithPrefix({
  label = null,
  labelInfo = null,
  id,
  value = '',
  name = '',
  onChange,
  onBlur = NOOP,
  showError = false,
  errorText = null,
  type = 'text',
  step = '',
  required = false,
  disabled = false,
  formClassName = '',
  inputClassName = '',
  placeholder = '',
  prefix,
  simpleError = false,
  customContent = '',
  errorTooltipPos = 'top',
}) {
  const inputErrorClass = showError && errorText ? 'is-invalid' : ''

  return (
    <div className={`form-group ${formClassName}`}>
      {label && (
        <label htmlFor={id}>
          {label}
          {labelInfo && (
            <Tooltip id={`label-info-${id}`} content={labelInfo} className="u-block">
              <Icon type={['fas', 'question-circle']} />
            </Tooltip>
          )}
          {required && <b> *</b>}
        </label>
      )}
      <div className="form-group--with-prefix">
        <div className="form-group-prepend">
          <span className={`form-group-text ${inputErrorClass}`}>{prefix}</span>
        </div>
        <input
          className={`form-control ${inputClassName} ${inputErrorClass}`}
          id={id}
          type={type}
          step={step}
          name={name}
          value={value}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
        />
      </div>

      {customContent !== '' && (
        <small className="text-default">{customContent}</small>
      )}

      {showError && errorText && (
        <div
          className={simpleError ? 'error-message' : `error-message--tooltip tooltip--${errorTooltipPos}`}
        >
          {errorText}
        </div>
      )}
    </div>
  )
}

InputFieldWithPrefix.propTypes = {
  label: PropTypes.string,
  labelInfo: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  showError: PropTypes.bool,
  errorText: PropTypes.string,
  type: PropTypes.string,
  step: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  formClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  prefix: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  simpleError: PropTypes.bool,
  customContent: PropTypes.string,
  errorTooltipPos: PropTypes.string,
}

export default InputFieldWithPrefix
